<template>
  <div class="consult-entry-wrap">
    <img class="kefu" src="../../../assets/images/kefu.png" alt="" />
    <ul class="list-wrap">
      <li class="item wx-code">
        <img
          class="item-icon"
          src="../../../assets/images/wx-icon.png"
          alt=""
        />
        <p class="item-title">微信咨询</p>
        <!-- 微信二维码 -->
        <div class="wx-qrcode-wrap">
          <div>
            <p class="title">微信咨询</p>
            <img
              class="qrcode"
              :src="
                'https://cdn.moguocdn.com/cdn/static/images/kehu_zixun_qrcode.png?t=' +
                time
              "
              alt=""
            />
            <p class="tips">手机扫码加我微信</p>
          </div>
        </div>
      </li>
      <li class="item appoint-item">
        <img
          class="item-icon"
          src="../../../assets/images/phone-icon.png"
          alt=""
        />
        <p class="item-title">电话咨询</p>
        <!-- 预约电话 -->
        <div class="appoint-phone" v-show="showAppoint">
          <div>
            <template v-if="!haveAppoint">
              <p class="title">预约电话</p>
              <p class="tips">专家顾问将在24小时内向你致电</p>
              <div class="input-wrap" :class="{ error: error }">
                <el-input
                  v-model.trim="phoneNumber"
                  class="phone-input"
                  placeholder="请填写您的手机号"
                  maxlength="11"
                  @input="handelInput"
                >
                </el-input>
                <span class="error-tips">请输入正确的手机号</span>
              </div>
              <button
                @click="submitPhone"
                v-preventReClick
                class="reservation-btn submit-btn"
              >
                立即预约
              </button>
            </template>
            <template v-else>
              <img
                class="success-icon"
                src="../../../assets/images/dui-icon.png"
                alt=""
              />
              <p class="success-text">预约成功</p>
              <p class="tips">专家顾问将在24小时内向你致电</p>
              <button
                @click="handleCloseAppoint"
                class="reservation-btn submit-btn"
              >
                我知道了
              </button>
            </template>
            <div class="phone-wrap">
              <img class="icon" src="../../../assets/images/phone.png" alt="" />
              <div class="info-wrap">
                <p class="time">咨询电话 10:00-21:00</p>
                <p class="phone">400-628-2024</p>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import {
  vailPhone,
  getHourTimestamp,
} from "@saas/components/src/utils/utils.js";
import { consultationApplication } from "@saas/server-api/src/organization";
export default {
  data: function () {
    return {
      showQrcode: false,
      phoneNumber: "",
      haveAppoint: false,
      error: false,
      loading: false,
      showAppoint: true,
      time: 0,
    };
  },
  methods: {
    handleCloseAppoint() {
      this.showAppoint = false;
      setTimeout(() => {
        this.showAppoint = true;
      }, 200);
    },
    handelInput() {
      if (this.error) {
        if (!vailPhone(this.phoneNumber)) {
          this.error = false;
        }
      }
    },
    submitPhone() {
      if (!vailPhone(this.phoneNumber)) {
        this.error = true;
        return false;
      }
      // 提交
      if (this.loading) return;
      this.loading = true;
      consultationApplication({
        mobile: this.phoneNumber,
      })
        .then((res) => {
          if (res.code === 1) {
            this.haveAppoint = true;
          } else {
            this.$showToast(res.message);
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.time = getHourTimestamp();
  },
};
</script>

<style lang="scss" scoped>
.consult-entry-wrap {
  z-index: 9;
  position: fixed;
  right: 40px;
  bottom: 100px;
  width: 50px;
  height: 114px;
  .kefu {
    position: absolute;
    top: -36px;
    left: 50%;
    transform: translateX(-50%);
    width: 42px;
    height: 42px;
  }
  .list-wrap {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    background: linear-gradient(225deg, #32c5ff 0%, #ce45f5 100%);
    border-radius: 10px;
  }
  .item {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1;
    border-bottom: 1px solid rgba($color: #fff, $alpha: 0.1);
    &:last-child {
      border-bottom: none;
    }
    .item-icon {
      width: 20px;
      height: 20px;
      margin-bottom: 2px;
    }
    .item-title {
      font-weight: 500;
      font-size: 10px;
      color: #ffffff;
      line-height: 14px;
    }
  }
  .input-wrap {
    position: relative;
    &.error {
      ::v-deep .el-input__inner {
        border-color: #f56c6c !important;
      }
      .error-tips {
        display: block;
      }
    }
    .error-tips {
      display: none;
      position: absolute;
      bottom: 0;
      left: 5px;
      color: #f56c6c;
      font-size: 12px;
      line-height: 24px;
    }
  }
  .wx-code {
    position: relative;
    box-sizing: content-box;
    &:hover {
      .wx-qrcode-wrap {
        opacity: 1;
        pointer-events: auto;
        & > div {
          padding-right: 36px;
          margin-right: -36px;
        }
      }
    }
  }
  .appoint-item {
    position: relative;
    box-sizing: content-box;
    &:hover {
      .appoint-phone {
        opacity: 1;
        pointer-events: auto;
        & > div {
          padding-right: 60px;
          margin-right: -36px;
        }
      }
    }
  }
  //   微信二维码
  .wx-qrcode-wrap {
    pointer-events: none;
    opacity: 0;
    transition: all 0.5s;
    position: absolute;
    bottom: -57px;
    right: 86px;
    width: 339px;
    height: 378px;
    background: #ffffff;
    box-shadow: 0px 6px 16px 0px rgba(102, 116, 107, 0.1);
    border-radius: 12px;
    border: 1px solid #f2f3f5;
    background-image: url("../../../assets/images/consult-entry/dialog-bg.png");
    background-repeat: no-repeat;
    background-size: 100% auto;
    & > div {
      height: 100%;
      padding-top: 29px;
    }
    .title {
      text-align: center;
      font-weight: 500;
      font-size: 26px;
      color: #000000;
      line-height: 37px;
      margin-bottom: 22px;
    }
    .qrcode {
      width: 215px;
      height: 215px;
      margin: 0 auto 20px;
    }
    .tips {
      padding-left: 10px;
      text-align: center;
      font-weight: 500;
      font-size: 18px;
      color: #0d1400;
      line-height: 25px;
      letter-spacing: 10px;
    }
  }
  //   预约电话
  .appoint-phone {
    pointer-events: none;
    opacity: 0;
    transition: all 0.5s;
    width: 339px;
    height: 378px;
    background: #ffffff;
    box-shadow: 0px 6px 16px 0px rgba(102, 116, 107, 0.1);
    border-radius: 12px;
    border: 1px solid #f2f3f5;
    background-image: url("../../../assets/images/consult-entry/dialog-bg.png");
    background-repeat: no-repeat;
    background-size: 100% auto;
    position: absolute;
    bottom: 0;
    right: 86px;
    & > div {
      height: 100%;
      padding: 29px 24px 0;
    }
    .title {
      font-weight: 500;
      font-size: 26px;
      color: #000000;
      line-height: 37px;
      margin-bottom: 6px;
    }
    .tips {
      font-weight: 500;
      font-size: 20px;
      color: #000000;
      line-height: 28px;
      margin-bottom: 27px;
    }
    ::v-deep .phone-input {
      margin-bottom: 24px;
      .el-input__inner {
        border-radius: 12px;
        border: 1px solid #e5e6eb;
        height: 56px;
        line-height: 56px;
        font-size: 20px;
        color: #0d1400;
      }
      .el-input__inner::placeholder {
        font-size: 20px;
        color: #858687;
        text-align: center;
      }
    }
    .success-icon {
      width: 56px;
      height: 56px;
      margin-top: 5px;
      margin: 0 auto 18px;
    }
    .success-text {
      font-weight: 500;
      font-size: 26px;
      color: #000000;
      line-height: 37px;
      margin-bottom: 6px;
      text-align: center;
    }
    .phone-wrap {
      padding-top: 15px;
      border-top: 1px solid #efefef;
      display: flex;
      align-items: center;
      .icon {
        width: 50px;
        height: 50px;
        margin-right: 12px;
      }
      .time {
        font-size: 18px;
        color: #575859;
        line-height: 25px;
      }
      .phone {
        font-size: 26px;
        color: #0d1400;
        line-height: 37px;
      }
    }
  }
  .submit-btn {
    width: 291px;
    height: 56px;
    background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
    border-radius: 12px;
    font-weight: 500;
    font-size: 20px;
    color: #ffffff;
    line-height: 28px;
    margin-bottom: 20px;
  }
}
</style>
